import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-boost';

import messages from '../lang/index';
import SearchPage from '../components/search/SearchPage.vue';
import VueLazyload from 'vue-lazyload';

Vue.use(VueApollo);
Vue.use(VueI18n);
Vue.use(VueLazyload, {
  lazyComponent: true,
});

document.addEventListener('DOMContentLoaded', () => {
  const csrfToken = document.head.querySelector('[name=csrf-token]').content;

  const apolloProvider = new VueApollo({
    defaultClient: new ApolloClient({
      uri: '/graphql',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-TOKEN': csrfToken,
      },
    }),
  });

  const allData = document.querySelector('search-page').dataset;

  const supportedLocales = ['en', 'cn'];
  let locale = allData.locale;
  if (!supportedLocales.includes(locale)) {
    locale = 'en';
  }

  const i18n = new VueI18n({
    locale,
    fallbackLocale: 'en',
    messages,
  });

  (() => new Vue({
    el: 'search-page',
    apolloProvider,
    i18n,
    render: h => h(SearchPage, {
      props: {
        country: allData.country,
        query: allData.query,
      },
    }),
  }))();
});
